import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import AvatarImg from "../../../Assets/images/icons/user.png";
import { notFound } from "../../../enums/mainEnums";
import Services from "./services";
import Subscriptions from "./subscriptions";

const MembershipDetailsPage = ({ data }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {
        <div className={`flex flex-col items-start`}>
          <div className="flex gap-8">
            <div className="user-data">
              <div className="flex flex-col items-start">
                <div className="user-name font-bold">{data?.name}</div>
                <div className="user-details flex gap-10">
                  <div className="user-created-at flex flex-col items-start">
                    <div>Added on</div>
                    <div className="font-bold">{data?.created_at}</div>{" "}
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Monthly Price</div>
                    <div className="font-bold">{data?.monthly_price} $</div>
                  </div>
                  <div className="user-created-at flex flex-col items-start">
                    <div>Services</div>
                    <div className="font-bold">{data?.services?.length}</div>
                  </div>
                  <div className="user-reviews flex flex-col items-start">
                    <div>Subscription</div>
                    <div className="font-bold">
                      {data?.subscriptions?.length}
                    </div>
                  </div>
                  <div className="user-reviews flex flex-col items-start">
                    <div>Active Subscription</div>
                    <div className="font-bold">
                      {data?.activeSubscriptions?.length}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Box
            sx={{
              borderBottom: 1,
              marginTop: "20px",
              borderColor: "divider",
              width: "100%",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Services" id="simple-tab-0" />
              <Tab label="Subscriptions" id="simple-tab-1" />
              <Tab label="Active Subscriptions" id="simple-tab-2" />
              <Tab label="Social Groups" id="simple-tab-3" />
            </Tabs>
          </Box>
          <div
            role="tabpanel"
            hidden={value !== 0}
            id={`simple-tabpanel-${0}`}
            aria-labelledby={`simple-tab-${0}`}
            className="w-full"
          >
            {value === 0 && <Services data={data?.services} />}
          </div>
          <div
            role="tabpanel"
            hidden={value !== 1}
            id={`simple-tabpanel-${1}`}
            aria-labelledby={`simple-tab-${1}`}
            className="w-full"
          >
            {value === 1 && (
              <Subscriptions data={data?.subscriptions} type={'all'}/>
            )}
          </div>
          <div
            role="tabpanel"
            hidden={value !== 2}
            id={`simple-tabpanel-${2}`}
            aria-labelledby={`simple-tab-${2}`}
            className="w-full"
          >
            {value === 2 && <Subscriptions data={data?.activeSubscriptions} type={'active'}/>}
          </div>
          <div
            role="tabpanel"
            hidden={value !== 3}
            id={`simple-tabpanel-${3}`}
            aria-labelledby={`simple-tab-${3}`}
            className="w-full"
          >
            {value === 3 && <div ></div>}
          </div>
        </div>
      }
    </>
  );
};

export default MembershipDetailsPage;
